import { render, staticRenderFns } from "./Receptionist.vue?vue&type=template&id=5e8f5578&scoped=true&"
import script from "./Receptionist.vue?vue&type=script&lang=js&"
export * from "./Receptionist.vue?vue&type=script&lang=js&"
import style0 from "./Receptionist.vue?vue&type=style&index=0&id=5e8f5578&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8f5578",
  null
  
)

export default component.exports